<script setup lang="ts">
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { computed, ref } from 'vue';
import FontAwesomeIcon from './FontAwesomeIcon.vue';

defineOptions({
  inheritAttrs: false,
});

withDefaults(
  defineProps<{
    maxWidth?: string;
    maxHeight?: string;
    hideClose?: boolean;
    scrollable?: boolean;
    blur?: boolean;
    closeOnBackdrop?: boolean;
  }>(),
  {
    maxWidth: '800px',
    maxHeight: '700px',
    hideClose: false,
    scrollable: true,
    blur: true,
    closeOnBackdrop: true,
  },
);

const mouseDownElement = ref<HTMLElement>();
const mouseUpElement = ref<HTMLElement>();
const backdrop = ref<HTMLDivElement>();

const hasClickedOnBackdrop = computed(() => {
  return (
    backdrop.value &&
    mouseDownElement.value === backdrop.value &&
    mouseUpElement.value === backdrop.value
  );
});

const emit = defineEmits<{
  (event: 'close'): void;
}>();
</script>

<template>
  <div
    ref="backdrop"
    class="tml-popup-backdrop body-overflow-hidden fixed top-0 left-0 w-screen h-dvh p-4 z-modal flex justify-center items-center bg-[#0006]"
    :class="{ 'backdrop-blur-md': blur }"
    @pointerdown="(e) => (mouseDownElement = e.target as HTMLElement)"
    @pointerup="
      (e) => {
        mouseUpElement = e.target as HTMLElement;

        if (hasClickedOnBackdrop && closeOnBackdrop) {
          emit('close');
        }
      }
    "
    @click.stop
  >
    <div
      class="relative bg-[--tml-page-background-color] rounded-[--tml-page-radius] cursor-auto w-full"
      :class="{ 'overflow-hidden': scrollable }"
      v-bind="$attrs"
      :style="{
        maxHeight,
        maxWidth,
      }"
      @click.stop
    >
      <div
        v-if="!hideClose"
        class="flex justify-center items-center absolute top-0 right-0 p-1 w-10 h-10 cursor-pointer z-10"
        @click="emit('close')"
      >
        <FontAwesomeIcon :icon="faXmark" class="h-6" />
      </div>
      <div class="h-full relative" :class="{ 'overflow-auto overscroll-contain': scrollable }">
        <slot />
      </div>
    </div>
  </div>
</template>
